"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConcernType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PatientConcern_1 = require("./PatientConcern");
var ConcernType_Factory = /** @class */ (function () {
    function ConcernType_Factory() {
    }
    ConcernType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Color: model.Color,
            Description: model.Description,
            PatientConcerns: model.PatientConcerns && model.PatientConcerns.map(function (i) { return PatientConcern_1.PatientConcern_Factory.CreateIncoming(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    ConcernType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Color: model.Color,
            Description: model.Description,
            PatientConcerns: model.PatientConcerns && model.PatientConcerns.map(function (i) { return PatientConcern_1.PatientConcern_Factory.CreateOutgoing(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return ConcernType_Factory;
}());
exports.ConcernType_Factory = ConcernType_Factory;
